/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import PropTypes from 'prop-types';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

export function RenderPdf({ data }) {
  const [pdfUrl, setPdfUrl] = useState(null);

  useEffect(() => {
    if (data) {
      try {
        const byteCharacters = atob(data); // Decodifica a Base64
        const byteNumbers = new Uint8Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
          byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const blob = new Blob([byteNumbers], { type: 'application/pdf' });
        setPdfUrl(URL.createObjectURL(blob)); // Cria URL para o Blob
      } catch (error) {
        console.error('Erro ao converter Base64 para PDF:', error);
      }
    }
  }, [data]);

  return (
    <div className="renderPdf">
      {pdfUrl && <iframe src={pdfUrl} className="iframe" />}
    </div>
  );
}

RenderPdf.propTypes = {
  data: PropTypes.string.isRequired,
};
